export default __webpack_public_path__ + "static/ads-header-23a428ffdd817a2914cfbacec0c60078.svg";